import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiPresignedUrlState {
    presignedUrl: string | null;
    status: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: CiPresignedUrlState = {
    presignedUrl: null,
    status: 'pending',
};

export const ciPresignedUrlReducer = createReducer(
    initialState,
    on(identityCardActions.getPresignedUrl, (state) => ({ ...state, presignedUrl: null, status: 'loading' as const })),
    on(identityCardActions.getPresignedUrlSuccess, (state, { payload }) => ({ ...state, presignedUrl: payload, status: 'loaded' as const })),
    on(identityCardActions.getPresignedUrlFail, (state) => ({ ...state, presignedUrl: null, status: 'error' as const })),
    on(identityCardActions.clearPresignedUrl, () => initialState)
);
